import { CSSProperties } from "react";

export const XSignetSvg = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <svg
      width={width}
      height={(width / 58) * 50}
      viewBox="0 0 58 50"
      fill="none"
      style={style}
    >
      <path
        d="M1.92792 22.1147C5.92792 10.5147 17.9279 2.94804 24.4279 0.614705C29.4279 7.61471 34.9279 10.2147 42.9279 16.6147C52.9279 24.6147 57.9279 31.1147 57.9279 37.1147C57.9279 41.9147 53.0946 46.7814 49.4279 49.6147C40.9279 49.6147 33.4279 48.1147 26.9279 48.1147C20.4279 48.1147 9.59459 48.948 3.92793 49.6147C0.927927 40.1147 -2.07208 33.7147 1.92792 22.1147Z"
        fill="url(#paint0_linear_285_7)"
      />
      <path
        d="M12.5 30.6147C8.89426 28.3611 5.5 24.1147 4 21.1147C4 25.1147 5.1 30.3147 9.5 33.1147C13.9 35.9147 20 37.1147 25.5 38.1147C19.5 35.1147 16.5 33.1147 12.5 30.6147Z"
        fill="url(#paint1_linear_285_7)"
      />
      <path
        d="M26.4175 24.2945C23.6961 21.0274 27 10.1147 23.5 3.1147C22.2505 6.91454 5.69483 14.0804 9 18.1147C12.3052 22.149 36.0876 32.9467 41 35.6147C36.2374 30.8906 29.4364 27.9189 26.4175 24.2945Z"
        fill="url(#paint2_linear_285_7)"
      />
      <path
        d="M24 20.6147C20.4226 13.1849 23.6666 6.28137 23.9999 4.61471C25.1666 5.78137 29.9 10.8147 41.5 19.6147C53.1 28.4147 54.1666 34.7814 52.9999 37.1147C43 37.1147 30.5 34.1147 24 20.6147Z"
        fill="#43352B"
      />
      <defs>
        <linearGradient
          id="paint0_linear_285_7"
          x1="28.964"
          y1="0.614705"
          x2="28.964"
          y2="49.6147"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A8875F" />
          <stop offset="1" stopColor="#724E3B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_285_7"
          x1="4"
          y1="22.6147"
          x2="25"
          y2="37.6147"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1AD72" />
          <stop offset="0.296875" stopColor="#C7A36B" />
          <stop offset="1" stopColor="#835F3D" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_285_7"
          x1="20.8418"
          y1="14.0396"
          x2="36.1053"
          y2="34.8489"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1AD72" />
          <stop offset="0.296875" stopColor="#C7A36B" />
          <stop offset="1" stopColor="#835F3D" />
        </linearGradient>
      </defs>
    </svg>
  );
};
